"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RoadTypeBar = RoadTypeBar;
var _Skeleton2 = _interopRequireDefault(require("@mui/material/Skeleton"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function RoadTypeBar({
  entries,
  values
}) {
  return values ? /*#__PURE__*/_react.default.createElement(_Box2.default, {
    borderRadius: 3,
    display: "flex",
    height: 6,
    overflow: "hidden"
  }, entries.map(({
    key,
    color
  }, index) => {
    const last = index === entries.length - 1;
    return /*#__PURE__*/_react.default.createElement(_Box2.default, {
      flexGrow: last ? 1 : 0,
      flexShrink: 0,
      key: key,
      sx: {
        backgroundColor: color
      },
      title: `${values[index]}%`,
      width: last ? undefined : `${values[index]}%`
    });
  })) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    height: 6,
    sx: {
      borderRadius: 3
    },
    variant: "rectangular"
  });
}